import type { ReactNode } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import { Icon } from '../Icon/Icon';
import { getTabClassNames } from './Tab.styles';
import type { TabProps } from './Tab.types';

export const Tab = <TKey extends string = string>(
  props: TabProps<TKey>,
): ReactNode => {
  const tabClassNames = getTabClassNames(props);
  return (
    // We wrap the button in a div to ensure proper styling of semi-transparent background (button) against the white background (tab),
    // yet maintaining support for interactive visual states (e.g., hover:bg-state-hover active:bg-state-press), which are implemented via CSS layered background already.
    <div className={tabClassNames.root}>
      <button
        className={tabClassNames.button}
        disabled={props.disabled}
        onClick={() => props.onSelect?.(props.id)}
        type='button'
        tabIndex={getAccessibleTabIndex(props.disabled)}
      >
        {props.icon && (
          <Icon
            glyph={props.icon}
            loading={props.loading}
            size='sm'
            className={tabClassNames.icon}
          />
        )}
        <span className={tabClassNames.label}>{props.label}</span>
        {props.badge}
        {props.closable && props.onClose && (
          <Icon
            glyph='fa-xmark-circle'
            iconStyle='duotone'
            onClick={(e) => {
              e.stopPropagation();
              props.onClose?.(props.id);
            }}
            className={tabClassNames.closeButton}
            size='xs'
          />
        )}
      </button>
    </div>
  );
};
